import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FAQS } from '../mock';
import PageHeader from '../components/PageHeader';
import ReviewsSection from '../components/ReviewsSection';
import useSiteSettings from '../hooks/useSiteSettings';

export default function FAQs() {
  const [open, setOpen] = useState(0);
  const settings = useSiteSettings();
  return (
    <main>
      <PageHeader title="FAQ" breadcrumb="FAQ" heroImage={settings.faqsHero} />

      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-12">
            <div className="eyebrow mb-3">FAQ</div>
            <h2 className="section-title text-3xl md:text-5xl mb-4">Your Questions</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">Welcome to Wrappus FAQ section. Whether you’re a first-time visitor or one of our loyal regulars, here are answers to your most common questions.</p>
          </div>

          <div className="space-y-3">
            {FAQS.map((f, i) => (
              <div key={i} className={`rounded-2xl border overflow-hidden transition-all ${open === i ? 'border-[#ED2E2E] shadow-lg' : 'border-gray-200 hover:border-[#ED2E2E]/50'}`}>
                <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between text-left px-6 py-5 bg-white hover:bg-[#FDF3EC] transition-colors">
                  <span className="font-heading font-semibold text-[#0F1C2E] text-base md:text-lg">{f.q}</span>
                  <ChevronDown size={20} className={`text-[#ED2E2E] shrink-0 ml-4 transition-transform ${open === i ? 'rotate-180' : ''}`} />
                </button>
                {open === i && (
                  <div className="px-6 pb-6 pt-2 bg-[#FDF3EC]/40">
                    <p className="text-gray-700 leading-relaxed whitespace-pre-line">{f.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <ReviewsSection />
    </main>
  );
}
